import Clipboard from './Clipboard';
export default Clipboard;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-clipboard/src/index.js